import * as React from 'react';

import * as styles from './cardProfile.module.scss';

export interface CardProfileProps {
  heading: string;
  subheading?: string;
  image?: Image;
  children: React.ReactNode;
}

const CardProfile = ({
  heading,
  subheading,
  image,
  children,
}: CardProfileProps) => (
  <figure className={styles.wrapper}>
    <div className={styles.content}>
      {image && (
        <div className={styles.imgContainer}>
          <img className={styles.img} src={image.url} alt={image.alt || ''} />
        </div>
      )}
      <h3 className={styles.heading}>{heading}</h3>
      {subheading && <h4 className={styles.subheading}>{subheading}</h4>}
      {children}
    </div>
  </figure>
);

export default CardProfile;
